import React from 'react'
import CoachList from './components/CoachList'

const App = () => {
  return <CoachList />
}

export default App
